// eslint-disable-next-line no-restricted-imports
import { Breadcrumb as AntBreadcrumb } from 'antd';
import styled from 'styled-components';

export const Breadcrumb = styled(AntBreadcrumb)`
  a {
    &:hover:not(:focus) {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: solid 1px;
    }
  }

  & > span:last-child a {
    color: var(--link-color);
  }
  & > ol > li > span.ant-breadcrumb-link > a {
    color: var(--link-color);
  }
`;
